import PropTypes from 'prop-types'
import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import Trans from 'next-translate/Trans'

export const CreatePassword = ({ name, login }) => {
  const { t } = useTranslation('common')

  return (
    <div className='registracija-content-napomena'>
      <h3>{t('VAŽNA NAPOMENA')}</h3>
      {/* <p><strong>{name}</strong> Vaše korisničko ime je <strong>{login}</strong> i služi vam za logovanje na sve naše
        sajtove. Molimo Vas da u nastavku strane popunite Vaš profil i kreirate <strong>ŠIFRU</strong> kako bi kasnije
        mogli da se logujete i <strong>upravljate svojim oglasima</strong>, koristeći sve funkcije koje Vam sajt pruža.
      </p> */}

      <Trans
        i18nKey='common:registracija-content-napomena'
        components={{
          p: <p />,
          strong: <strong />
        }}
        values={{ name: name, login }}
        defaultTrans={`
        <p><strong>{{name}}</strong> Vaše korisničko ime je <strong>{{login}}</strong> i služi vam za logovanje na sve naše
        sajtove. Molimo Vas da u nastavku strane popunite Vaš profil i kreirate <strong>ŠIFRU</strong> kako bi kasnije
        mogli da se logujete i <strong>upravljate svojim oglasima</strong>, koristeći sve funkcije koje Vam sajt pruža.
        </p>
        `}
      />
    </div>
  )
}

CreatePassword.propTypes = {
  login: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired
}
